export default __webpack_public_path__ + "static/media/batours.cf6788d0.svg";